module.exports = __webpack_public_path__ + "static/media/01.ac68ff32.mp3";